var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Tableau de bord") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Panneau de bord flottant avec tuiles et courbe.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 173.1 L 444.6 285.3 L 261.7 390.9 L 67.4 278.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 235.8,
    x2: 124.5,
    y2: 301.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 276,
    y1: 257.2,
    x2: 161.7,
    y2: 323.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 313.2,
    y1: 278.7,
    x2: 198.8,
    y2: 344.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 350.3,
    y1: 300.1,
    x2: 236,
    y2: 366.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 387.5,
    y1: 321.6,
    x2: 273.1,
    y2: 387.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 235.8,
    x2: 387.5,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 200.7,
    y1: 257.8,
    x2: 349.4,
    y2: 343.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 162.6,
    y1: 279.8,
    x2: 311.3,
    y2: 365.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 124.5,
    y1: 301.8,
    x2: 273.1,
    y2: 387.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 384.6 261.9 L 276 324.6 L 276 333.1 L 384.6 270.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 127.4 238.8 L 276 324.6 L 276 333.1 L 127.4 247.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 236 176.1 L 384.6 261.9 L 276 324.6 L 127.4 238.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 236,
    y1: 184.7,
    x2: 236,
    y2: 176.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 236,
    y1: 184.7,
    x2: 384.6,
    y2: 270.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 236,
    y1: 184.7,
    x2: 127.4,
    y2: 247.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 236 176.1 L 384.6 261.9 L 276 324.6 L 127.4 238.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 384.6,
    y1: 261.9,
    x2: 384.6,
    y2: 270.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 276,
    y1: 324.6,
    x2: 276,
    y2: 333.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 127.4,
    y1: 238.8,
    x2: 127.4,
    y2: 247.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 384.6,
    y1: 270.4,
    x2: 276,
    y2: 333.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 276,
    y1: 333.1,
    x2: 127.4,
    y2: 247.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 273.1 192.6 L 238.9 212.4 L 238.9 230.5 L 273.1 210.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 201.7 190.9 L 238.9 212.4 L 238.9 230.5 L 201.7 209.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 236 171.1 L 273.1 192.6 L 238.9 212.4 L 201.7 190.9 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 236,
    y1: 189.3,
    x2: 236,
    y2: 171.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 236,
    y1: 189.3,
    x2: 273.1,
    y2: 210.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 236,
    y1: 189.3,
    x2: 201.7,
    y2: 209.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 236 171.1 L 273.1 192.6 L 238.9 212.4 L 201.7 190.9 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 273.1,
    y1: 192.6,
    x2: 273.1,
    y2: 210.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 238.9,
    y1: 212.4,
    x2: 238.9,
    y2: 230.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 201.7,
    y1: 190.9,
    x2: 201.7,
    y2: 209.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 273.1,
    y1: 210.7,
    x2: 238.9,
    y2: 230.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 238.9,
    y1: 230.5,
    x2: 201.7,
    y2: 209.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 316 204.1 L 281.7 223.9 L 281.7 255.3 L 316 235.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 244.6 202.5 L 281.7 223.9 L 281.7 255.3 L 244.6 233.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 278.9 182.7 L 316 204.1 L 281.7 223.9 L 244.6 202.5 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 278.9,
    y1: 214,
    x2: 278.9,
    y2: 182.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 278.9,
    y1: 214,
    x2: 316,
    y2: 235.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 278.9,
    y1: 214,
    x2: 244.6,
    y2: 233.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 278.9 182.7 L 316 204.1 L 281.7 223.9 L 244.6 202.5 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 316,
    y1: 204.1,
    x2: 316,
    y2: 235.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 281.7,
    y1: 223.9,
    x2: 281.7,
    y2: 255.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 244.6,
    y1: 202.5,
    x2: 244.6,
    y2: 233.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 316,
    y1: 235.5,
    x2: 281.7,
    y2: 255.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 281.7,
    y1: 255.3,
    x2: 244.6,
    y2: 233.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 358.9 248.7 L 324.6 268.5 L 324.6 280 L 358.9 260.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 287.4 247 L 324.6 268.5 L 324.6 280 L 287.4 258.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 321.7 227.2 L 358.9 248.7 L 324.6 268.5 L 287.4 247 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 321.7,
    y1: 238.8,
    x2: 321.7,
    y2: 227.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 321.7,
    y1: 238.8,
    x2: 358.9,
    y2: 260.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 321.7,
    y1: 238.8,
    x2: 287.4,
    y2: 258.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 321.7 227.2 L 358.9 248.7 L 324.6 268.5 L 287.4 247 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 358.9,
    y1: 248.7,
    x2: 358.9,
    y2: 260.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 324.6,
    y1: 268.5,
    x2: 324.6,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 287.4,
    y1: 247,
    x2: 287.4,
    y2: 258.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 358.9,
    y1: 260.2,
    x2: 324.6,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 324.6,
    y1: 280,
    x2: 287.4,
    y2: 258.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "a flow",
    d: "M 166 223.4 L 190.6 219.5 L 215.1 241.9 L 239.7 236.3 L 264.3 258.7 L 288.9 254.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 190.6,
    cy: 219.5,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 190.6,
    cy: 219.5,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d4",
    cx: 239.7,
    cy: 236.3,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 239.7,
    cy: 236.3,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d9",
    cx: 288.9,
    cy: 254.8,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 288.9,
    cy: 254.8,
    r: 3.6
  })), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 188.8,
    y1: 216.2,
    x2: 243.1,
    y2: 247.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 178.8,
    y1: 221.9,
    x2: 233.1,
    y2: 253.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 168.8,
    y1: 227.7,
    x2: 223.1,
    y2: 259.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 256,
    y1: 311,
    x2: 256,
    y2: 260.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay);
export default __webpack_public_path__ + "static/media/display.d23bd263845c1210e8f519874134419b.svg";
export { ForwardRef as ReactComponent };